import React from 'react';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

export default class MuiFileInputField extends React.Component {
    render() {
        const {
            id,
            title,
            options,
            error,
            errorText,
            helperText,
            required,
            disabled,
            multiple,
            inputValue,
            onBlur,
            onFocus,
            uiSchema
        } = this.props;

        const { classes = {} } = uiSchema;
        const onChange = ({ target: { files } }) => {
            if (multiple) {
                this.props.onChange(id, files);
            } else {
                this.props.onChange(id, files[0]);
            }
        };

        const fileNames = [];

        if (inputValue && inputValue.length && multiple) {
            for (let i = 0; i < inputValue.length; i++) {
                if (inputValue[i] && inputValue[i].name) {
                    fileNames.push(inputValue[i].name);
                }
            }
        } else if (inputValue && inputValue.name) {
            fileNames.push(inputValue.name);
        }

        return (
            <React.Fragment>
                <FormControl
                    required={ required }
                    error={ error }
                    component="fieldset"
                    classes={{
                        root: classes.fieldSet || ''
                    }}
                >
                    { title ? <FormHelperText
                        classes={{
                            root: classes.titleContainer || ''
                        }}
                    >{ title }</FormHelperText> : null }
                    <input
                        id={ id }
                        accept={ options.accept }
                        className={ classes.input }
                        multiple={ multiple }
                        type="file"
                        onChange={ !disabled ? onChange : null }
                        required={ required }
                        disabled={ disabled }
                        style={{
                            display: 'none'
                        }}
                    />
                    <label htmlFor={ id }>
                        <Button
                            variant={ options.variant ? options.variant : 'contained' }
                            color={ options.color ? options.color : 'primary' }
                            component="span"
                            classes={{
                                root: classes.button || ''
                            }}
                            disabled={ disabled }
                            onBlur={ onBlur && (() => onBlur({ id, value: inputValue })) }
                            onFocus={ onFocus && (() => onFocus({ id, value: inputValue })) }
                        >
                            { options.buttonText }
                        </Button>
                    </label>
                    { helperText ? <FormHelperText
                        classes={{
                            root: classes.helperContainer || ''
                        }}
                    >{ helperText }</FormHelperText> : null }
                    { options.showSelectedFiles && fileNames.length ? <FormHelperText
                        classes={{
                            root: classes.selectedFilesContainer || ''
                        }}
                    >{ `${options.selectedFilesText || ''} ${fileNames.join(', ')}` }</FormHelperText> : null }
                    { errorText ? <FormHelperText
                        classes={{
                            root: classes.errorContainer || ''
                        }}
                    >{ errorText }</FormHelperText> : null }
                </FormControl>
            </React.Fragment>
        );
    }
}

MuiFileInputField.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    error: PropTypes.bool,
    errorText: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    options: PropTypes.shape({
        variant: PropTypes.string,
        accept: PropTypes.string,
        color: PropTypes.string,
        buttonText: PropTypes.string,
        showSelectedFiles: PropTypes.bool,
        selectedFilesText: PropTypes.string
    }),
    uiSchema: PropTypes.shape({
        classes: PropTypes.shape({
            fieldSet: PropTypes.string,
            input: PropTypes.string,
            button: PropTypes.string,
            titleContainer: PropTypes.string,
            helperContainer: PropTypes.string,
            selectedFilesContainer: PropTypes.string,
            errorContainer: PropTypes.string
        })
    }),
    inputValue: PropTypes.any,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    helperText: PropTypes.string,
    onChange: PropTypes.func
};

MuiFileInputField.defaultProps = {
    title: '',
    error: false,
    errorText: '',
    required: false,
    disabled: false,
    multiple: false,
    options: {
        variant: 'contained',
        accept: '',
        color: 'primary',
        buttonText: 'upload file',
        showSelectedFiles: false,
        selectedFilesText: ''
    },
    uiSchema: {},
    inputValue: null,
    helperText: ''
};
